import { ActionFunctionArgs, redirect } from 'react-router-dom'
import { z } from 'zod'

import { selectBMIHighPath, selectHealthWarningPath } from '@/router/paths'
import { bmiSchema } from '@/schema.ts'
import { useAppointmentStore } from '@/store.ts'
import { checkBMICompliance } from '@/utils/showBMIForCategory.ts'

interface ActionData {
  errors?: z.ZodIssue[]
  error?: string
}

const action = async ({
  params,
  request,
}: ActionFunctionArgs): Promise<ActionData | Response> => {
  const { appointmentType, category, doctorId, locationId } = params
  if (!category || !appointmentType) {
    return redirect('/404')
  }
  const { setBMIData } = useAppointmentStore.getState()
  const formData = await request.formData()
  const bmiData = {
    height: Number(formData.get('height')),
    weight: Number(formData.get('weight')),
  }
  const result = bmiSchema.safeParse(bmiData)
  if (!result.success) {
    setBMIData(bmiData)
    return { errors: result.error.issues }
  }

  const calculatedBmi = bmiData.weight / Math.pow(bmiData.height / 100, 2)
  setBMIData({
    ...bmiData,
    calculatedBmi,
  })

  if (checkBMICompliance(appointmentType, category, calculatedBmi)) {
    return redirect(
      selectHealthWarningPath({
        appointmentType,
        category,
        doctorId,
        locationId,
      }),
    )
  } else {
    return redirect(
      selectBMIHighPath({
        appointmentType,
        bmi: calculatedBmi,
        category,
        doctorId,
        locationId,
      }),
    )
  }
}

export type { ActionData }
export { action }
